import { MESApiService, type spParameter } from "../../../../../services";

const getIhPath = () =>
	localStorage.getItem("ihPath") || "[mssql2022].[IH_100020].[ih]";

//tags
export const getTagsTree = async () => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	const resp = await apiService.callV2(
		getIhPath() + ".[GetTagsTree]",
		parameters,
	);
	return resp;
};

export const deleteTagFolder = async (TagFolderId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];
	const backendOffset = 1000000;

	if (TagFolderId && TagFolderId > backendOffset) {
		TagFolderId = TagFolderId - backendOffset;
	}

	parameters.push({ name: "TagFolderId", value: TagFolderId });

	const resp = await apiService.callV2(
		getIhPath() + ".[DeleteTagFolder]",
		parameters,
	);
	return resp;
};

export const upsertTagFolder = async (
	TagFolderId: number | null,
	ParentTagFolderId: number | null,
	TagFolderName: string,
	IsActive: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];
	const backendOffset = 1000000;

	if (TagFolderId && TagFolderId > backendOffset) {
		TagFolderId = TagFolderId - backendOffset;
	}
	if (ParentTagFolderId && ParentTagFolderId > backendOffset) {
		ParentTagFolderId = ParentTagFolderId - backendOffset;
	}

	parameters.push({ name: "TagFolderId", value: TagFolderId });
	parameters.push({ name: "ParentTagFolderId", value: ParentTagFolderId });
	parameters.push({ name: "TagFolderName", value: TagFolderName });
	parameters.push({ name: "IsActive", value: IsActive });

	const resp = await apiService.callV2(
		getIhPath() + ".[UpsertTagFolder]",
		parameters,
	);
	return resp;
};

export const changeTagFolderToTag = async (
	TagId: number | null,
	TagFolderId: number | null,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];
	const backendOffset = 1000000;

	if (TagFolderId && TagFolderId > backendOffset) {
		TagFolderId = TagFolderId - backendOffset;
	}

	parameters.push({ name: "TagId", value: TagId });
	parameters.push({ name: "TagFolderId", value: TagFolderId });

	const resp = await apiService.callV2(
		getIhPath() + ".[ChangeTagFolderToTag]",
		parameters,
	);
	return resp;
};
/* */

export const getSeriesData = async (
	TagIds: string,
	Start: number | null,
	End: number | null,
	SampleCount: number,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "TagIds", value: TagIds });
	parameters.push({ name: "Start", value: Start });
	parameters.push({ name: "End", value: End });
	parameters.push({ name: "SampleCount", value: SampleCount });

	const resp = await apiService.callV2(
		getIhPath() + ".[GetSeriesData]",
		parameters,
	);
	return resp;
};

export const saveTagDefaults = async (
	TagId: number,
	Alias: string,
	Color: string,
	MinScale: number,
	MaxScale: number,
	Unit: string,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "TagId", value: TagId });
	parameters.push({ name: "Alias", value: Alias });
	parameters.push({ name: "Color", value: Color });
	parameters.push({ name: "MinScale", value: MinScale });
	parameters.push({ name: "MaxScale", value: MaxScale });
	parameters.push({ name: "Unit", value: Unit });

	const resp = await apiService.callV2(
		getIhPath() + ".[SaveTagDefaults]",
		parameters,
	);
	return resp;
};

//views

export const getViews = async (Search: string | null) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "Search", value: Search });

	const resp = await apiService.callV2(getIhPath() + ".[GetViews]", parameters);
	return resp;
};

export const upsertView = async (
	ViewId: number | null,
	ViewName: string,
	isPublic: boolean,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ViewId", value: ViewId });
	parameters.push({ name: "ViewName", value: ViewName });
	parameters.push({ name: "isPublic", value: isPublic });

	const resp = await apiService.callV2(
		getIhPath() + ".[UpsertView]",
		parameters,
	);
	return resp;
};

export const deleteView = async (ViewId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ViewId", value: ViewId });

	const resp = await apiService.callV2(
		getIhPath() + ".[DeleteView]",
		parameters,
	);
	return resp;
};

//viewTags
export const getViewTags = async (ViewId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ViewId", value: ViewId });

	const resp = await apiService.callV2(
		getIhPath() + ".[GetViewTags]",
		parameters,
	);
	return resp;
};

export const upsertViewTag = async (
	ViewId: number,
	TagId: number,
	Color: string,
	MinScale: number,
	MaxScale: number,
	IsVisible: boolean,
	IsAutoScale: boolean,
	Unit: string,
) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ViewId", value: ViewId });
	parameters.push({ name: "TagId", value: TagId });
	parameters.push({ name: "Color", value: Color });
	parameters.push({ name: "MinScale", value: MinScale });
	parameters.push({ name: "MaxScale", value: MaxScale });
	parameters.push({ name: "IsVisible", value: IsVisible });
	parameters.push({ name: "IsAutoScale", value: IsAutoScale });
	parameters.push({ name: "Unit", value: Unit });

	const resp = await apiService.callV2(
		getIhPath() + ".[UpsertViewTag]",
		parameters,
	);
	return resp;
};

export const deleteViewTag = async (ViewId: number, TagId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ViewId", value: ViewId });
	parameters.push({ name: "TagId", value: TagId });

	const resp = await apiService.callV2(
		getIhPath() + ".[DeleteViewTag]",
		parameters,
	);
	return resp;
};
export const deleteAllViewTagsFromView = async (ViewId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [];

	parameters.push({ name: "ViewId", value: ViewId });

	const resp = await apiService.callV2(
		getIhPath() + ".[DeleteAllViewTagsFromView]",
		parameters,
	);
	return resp;
};
